/**
 * Wild Workouts trainings
 * TODO
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Training model module.
 * @module model/Training
 * @version 1.0.0
 */
class Training {
    /**
     * Constructs a new <code>Training</code>.
     * @alias module:model/Training
     * @param uuid {String} 
     * @param user {String} 
     * @param userUuid {String} 
     * @param notes {String} 
     * @param time {Date} 
     * @param canBeCancelled {Boolean} 
     * @param moveRequiresAccept {Boolean} 
     */
    constructor(uuid, user, userUuid, notes, time, canBeCancelled, moveRequiresAccept) { 
        
        Training.initialize(this, uuid, user, userUuid, notes, time, canBeCancelled, moveRequiresAccept);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, uuid, user, userUuid, notes, time, canBeCancelled, moveRequiresAccept) { 
        obj['uuid'] = uuid;
        obj['user'] = user;
        obj['userUuid'] = userUuid;
        obj['notes'] = notes;
        obj['time'] = time;
        obj['canBeCancelled'] = canBeCancelled;
        obj['moveRequiresAccept'] = moveRequiresAccept;
    }

    /**
     * Constructs a <code>Training</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Training} obj Optional instance to populate.
     * @return {module:model/Training} The populated <code>Training</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Training();

            if (data.hasOwnProperty('uuid')) {
                obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = ApiClient.convertToType(data['user'], 'String');
            }
            if (data.hasOwnProperty('userUuid')) {
                obj['userUuid'] = ApiClient.convertToType(data['userUuid'], 'String');
            }
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
            if (data.hasOwnProperty('time')) {
                obj['time'] = ApiClient.convertToType(data['time'], 'Date');
            }
            if (data.hasOwnProperty('canBeCancelled')) {
                obj['canBeCancelled'] = ApiClient.convertToType(data['canBeCancelled'], 'Boolean');
            }
            if (data.hasOwnProperty('moveRequiresAccept')) {
                obj['moveRequiresAccept'] = ApiClient.convertToType(data['moveRequiresAccept'], 'Boolean');
            }
            if (data.hasOwnProperty('proposedTime')) {
                obj['proposedTime'] = ApiClient.convertToType(data['proposedTime'], 'Date');
            }
            if (data.hasOwnProperty('moveProposedBy')) {
                obj['moveProposedBy'] = ApiClient.convertToType(data['moveProposedBy'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} uuid
 */
Training.prototype['uuid'] = undefined;

/**
 * @member {String} user
 */
Training.prototype['user'] = undefined;

/**
 * @member {String} userUuid
 */
Training.prototype['userUuid'] = undefined;

/**
 * @member {String} notes
 */
Training.prototype['notes'] = undefined;

/**
 * @member {Date} time
 */
Training.prototype['time'] = undefined;

/**
 * @member {Boolean} canBeCancelled
 */
Training.prototype['canBeCancelled'] = undefined;

/**
 * @member {Boolean} moveRequiresAccept
 */
Training.prototype['moveRequiresAccept'] = undefined;

/**
 * @member {Date} proposedTime
 */
Training.prototype['proposedTime'] = undefined;

/**
 * @member {String} moveProposedBy
 */
Training.prototype['moveProposedBy'] = undefined;






export default Training;

